import React from 'react'
import { array } from 'prop-types'
import { rem } from 'polished'
import styled from 'styled-components'
import { Flex } from 'rebass'

import media, { Grid } from '../../utils/style'
import { Link } from 'react-scroll'

const Wrapper = styled(Flex)`
  position: relative;
  background: white;
`
const Router = styled(Flex)`
  width: 100%;
  display: none;
  ${media.LargeScreenUp`
    display: flex;
  `};
`

const RouterItem = styled(Grid)`
  text-align: center;
  flex-grow: 1;
  cursor: pointer;
  align-items: center;

  a {
    display: block;
    width: 100%;
    text-decoration: none;
    text-transform: uppercase;
    font-size: ${rem('14.5px')};
    font-weight: 600;
    letter-spacing: 0.12em;
    color: ${(props) => props.theme.colors.grey_light};
    padding-bottom: ${rem(8)};
    transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    background-color: 0.3s ${(props) => props.theme.ease.ease_out_expo};
  }

  &:hover a {
    opacity: 1;
    color: ${(props) => props.theme.colors.grey_op80};
  }

  &.active a {
    position: relative;
    color: ${(props) => props.theme.colors.blue};
    &::after {
      content: '';
      width: 100%;
      height: 2px;
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      background-color: ${(props) => props.theme.colors.blue};
    }
  }
`

class ContentContextNavigation extends React.PureComponent {
  render() {
    return (
      <Wrapper flexWrap="wrap" mb={[60]}>
        <Router py={30}>
          {this.props.sections.map((section) => (
            <RouterItem
              className={section.root ? 'active' : null}
              key={`ccn:${section.slug}`}
              ml="auto"
            >
              <Link to={section.slug} smooth offset={-10} duration={500}>
                {section.label}
              </Link>
            </RouterItem>
          ))}
        </Router>
      </Wrapper>
    )
  }
}

ContentContextNavigation.defaultProps = {
  sections: []
}
ContentContextNavigation.propTypes = {
  sections: array
}

export default ContentContextNavigation
